import { render, staticRenderFns } from "./Conferencing.vue?vue&type=template&id=0352e4e4"
import script from "./Conferencing.vue?vue&type=script&lang=js"
export * from "./Conferencing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports